<template>
	<div class="page-advice">
    <div class="top">
      <div class="doctor-info">
        <div class="doctor-info-left-area">
          <van-image class="avatar" round width="36" height="36" :src="msgContent.doctorAvatar | imgUrl"/>
          <div>
            <p style="display: flex; align-items: center; flex-wrap: wrap;">
              <span class="doctor-name">{{msgContent.doctorName}}</span>
              <span class="doctor-title-department">{{msgContent.jobTitle}} | {{msgContent.department}}</span>
            </p>
            <span class="hospital">
              {{msgContent.hospitalName}}
            </span>
          </div>
        </div>
		    <van-button class="btn-consult" type="info" size="small" @click="handleBtnConsutClick">联系医生</van-button>
      </div>
      <div class="content">
        <span class="text">
          {{msgContent.text}}
        </span>
        <div class="img-list" v-if="msgContent.imageList && msgContent.imageList.length > 0">
          <van-image v-for="(src, index) in msgContent.imageList" :key="index" class="img" :width="imgWidth" :height="imgWidth" :src="src | imgUrl" @click="handleImgClick(index)"/>
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-button class="btn-consult" block type="info" @click="handleBtnConsutClick">联系医生</van-button>
    </div>
		<!-- <van-image-preview closeable v-model="showBigImage" :images="[content]">
			<template v-slot:index><span></span></template>
		</van-image-preview> -->
	</div>
</template>

<script>
import { ImagePreview } from '@zyf2e/capui-mobile';

export default {
	name: 'message',
	data() {
		return {
      msgContent: {
        imageList: []
      },
      imgWidth: ((window.innerWidth - 56)/3).toFixed(0) + 'px'
		}
	},
	mounted() {
		this.$fetch.getMessageDetail({ msgId: this.$route.query.msgId }).then((res) => {
      this.msgContent = res;
		})
	},
	methods: {
		handleBtnConsutClick() {
			this.$router.push({
        name: 'DoctorDetail',
        params: {
          id: this.msgContent.doctorId
        }
      });
		},
    handleImgClick(index) {
      ImagePreview({
        images: this.msgContent.imageList,
        startPosition: index
      });
    }
	}
};
</script>

<style lang="less" scoped>
.page-advice {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .top {
    flex: 1 1 auto;
    overflow: auto;
    .doctor-info {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      padding: 16px;
      background: #fff;
      margin-bottom: 12px;
      .doctor-info-left-area {
        display: flex;
        justify-content: space-between;
        .avatar {
          margin-right: 16px;
          flex: 0 0 auto;
        }
        .doctor-name {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #262626;
          line-height: 16px;
          margin-right: 4px;
          margin-bottom: 4px;
        }
        .doctor-title-department {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #262626;
          line-height: 18px;
          margin-bottom: 4px;
        }
      }
      .btn-consult {
        flex: 0 0 auto;
      }
      .hospital {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8C8C8C;
        line-height: 18px;
      }
    }
    .content {
      padding: 16px 16px 4px 16px;
      background: #fff;
      .text {
        display: block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #595959;
        line-height: 20px;
        margin-bottom: 16px;
      }
      .img-list {
        .img {
          margin-bottom: 12px;
          margin-right: 12px;
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .bottom {
    flex: 0 0 auto;
    padding: 8px 16px;
    background: #fff;
  }
}
</style>
